<template>
  <div class="main-malfunction">
    <div class="malf-black-background">
    </div>
    <!--    <div class="question-image">-->
    <!--      <img src="../../static/series/cutbed/question.png" alt="">-->
    <!--    </div>-->

    <div class="malfunction-image1">
      <img src="../../static/Malfunction/图片9.png">
    </div>
    <div class="malfunction-image2">
      <img src="../../static/Malfunction/图片10.png">
    </div>
    <div class="malfunction-text">
      <div class="malfunction-text1">
        {{ $t('series.malfunction_text1') }}<br>
        {{ $t('series.malfunction_text2') }}
      </div>
      <div class="malfunction-text2">
        {{ $t('series.malfunction_text3') }}<br>
        {{ $t('series.malfunction_text4') }}<br>
        {{ $t('series.malfunction_text5') }}
      </div>
      <div class="malfunction-text3">
        {{ $t('series.malfunction_text6') }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "malfunction",
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {
      // 第一轮动画，仅显示部分字体及黑色背景框
      this.$gsap.set('.malf-black-background', {
        zIndex: 5
      })
      this.$gsap.set('.malfunction-text', {
        zIndex: 10,
      })

      this.$gsap.set(['.malfunction-image1'], {
        opacity: 0,
      })

      this.$gsap.set(['.malfunction-image2'], {
        scale: 0.95,
        x: '-19vw',
        y: '-10vw',
      })

      this.$gsap.set(['.malfunction-text2', '.malfunction-text3'], {
        x: -200,
        opacity: 0,
      })

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.main-malfunction',
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          // scrub: 1,
          once: true,
          toggleActions: 'play none none none'
        }
      })

      // 进场
      masterTimeline.from(['.malfunction-text1', '.question-image'], {
        opacity: 0,
        y: 50,
        duration: 2
      }, 0.3)

      // 文字向上消失,
      masterTimeline.to(['.malfunction-text1'], {
        opacity: 0,
        y: -100,
        duration: 2,
      }, 2.3)

      // malf-black-background
      masterTimeline.to(['.malf-black-background'], {
        opacity: 0,
        '--left': '0%',   // 左边界左移
        '--right': '100%',  // 右边界右移
        '--top': '0%',    // 上边界上移
        '--bottom': '100%', // 下边界下移
        duration: 3,
      }, 2.3)

      masterTimeline.to(['.malfunction-image2'], {
        scale: 1,
        x: '0vw',
        y: '0vw',
        duration: 3,
      }, 2.3)

      // 显示图片2
      masterTimeline.to(['.malfunction-image2'], {
        zIndex: 6,
        opacity: 1,
        duration: 2,
      }, 5)

      // 显示遮罩
      masterTimeline.to('.malfunction-image1', {
        opacity: 1,
        duration: 2,
      }, 6)

      // 第二段文字进场
      masterTimeline.to(['.malfunction-text2', '.malfunction-text3'], {
        opacity: 1,
        duration: 2,
        x: 0
      }, 7)
    })
  }
}
</script>
<style scoped>
.main-malfunction {
  position: relative;
  height: 120vh;
  background-color: #161617;
  box-sizing: border-box;
  overflow: hidden;
}

.malf-black-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
  pointer-events: none;
  /* 双线性渐变组合：左右+上下黑色，中间长方形透明 */

  /* 自定义透明大小 */
  --left: 38%;
  --right: 48%;
  --top: 55%;
  --bottom: 75%;

  background: /* 左右黑色区域 */ linear-gradient(to right, #000 0%, #000 var(--left), transparent var(--left), transparent var(--right), #000 var(--right), #000 100%),
    /* 上下黑色区域 */ linear-gradient(to bottom, #000 0%, #000 var(--top), transparent var(--top), transparent var(--bottom), #000 var(--bottom), #000 100%);
}

.malfunction-image1 {
  position: absolute;
  width: 105%;
  height: 100%;
  top: 0;
  z-index: 10;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.malfunction-image2 {
  position: absolute;
  width: 100%;
  top: 0;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

.malfunction-text {
  position: absolute;
  z-index: 3;
  color: white;
  left: 30%;
  top: 40%;
  text-align: left;
}

.malfunction-text1 {
  position: absolute;
  font-size: 3em;
  left: 50%;
  width: 100%;
}

.malfunction-text2 {
  z-index: 10;
  margin-top: 50px;
  font-size: 2em;
}

.malfunction-text3 {
  z-index: 10;
  font-size: 2em;
  color: #83cbeb;
}

/* 平板设备适配 */
@media (max-width: 992px) {
  .main-malfunction {
    height: 800px;
    margin-top: 80px;
  }

  .malfunction-text {
    left: 25%;
    top: 35%;
  }

  .malfunction-text1 {
    font-size: 2.2em;
  }

  .malfunction-text2,
  .malfunction-text3 {
    font-size: 1.6em;
  }
}

/* 手机设备适配 (767px以下) */
@media (max-width: 767px) {
  .main-malfunction {
    height: 600px;
    margin-top: 60px;
  }

  .malfunction-image2 {
    left: 0; /* 移除左侧偏移，避免图片显示不完整 */
  }

  .malfunction-text {
    left: 15%;
    top: 30%;
    max-width: 70%;
  }

  .malfunction-text1 {
    font-size: 1.5em;
  }

  .malfunction-text2,
  .malfunction-text3 {
    font-size: 1.1em;
  }
}

/* 小屏手机额外适配 (375px以下) */
@media (max-width: 375px) {
  .main-malfunction {
    height: 225px;
    margin-top: 40px;
  }

  .malfunction-text {
    left: 10%;
    top: 10%;
    max-width: 80%;
  }

  .malfunction-text1 {
    font-size: 1.3em;
  }

  .malfunction-text2,
  .malfunction-text3 {
    font-size: 0.95em;
  }
}
</style>

